import { render, staticRenderFns } from "./userGw.vue?vue&type=template&id=a87b3976&scoped=true&"
import script from "./userGw.vue?vue&type=script&lang=js&"
export * from "./userGw.vue?vue&type=script&lang=js&"
import style0 from "./userGw.vue?vue&type=style&index=0&id=a87b3976&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87b3976",
  null
  
)

export default component.exports